import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import Checkbox from '../../Checkbox/Checkbox.js';
import '../../Checkbox/CheckboxList.js';

const Container = styled('div') `
  display: flex;
  flex-direction: row;
`;
const Label = styled(MuiTypography) `
  color: ${({ theme }) => theme.palette.N20.main};
  margin-left: 8px;
`;
const BooleanField = ({ field, value, onChange }) => {
    var _a;
    const getValue = () => {
        if (typeof value !== 'undefined')
            return value;
        return field.default;
    };
    return (jsxs(Container, { children: [jsx(Checkbox, { "data-testid": "boolean-field", name: field.name, checked: getValue(), onChange: event => onChange(event.target.checked), size: "medium", disabled: field.disabled }), jsxs(Label, { children: [(_a = field.meta) === null || _a === void 0 ? void 0 : _a.label, field.required && jsx(Fragment, { children: " *" })] })] }));
};

export { BooleanField as default };
//# sourceMappingURL=BooleanField.js.map
